import { RequestStateType, RequestType } from '@uag/welcome-shared/src/api/models';

export interface AppliedFiltersType {
    state: RequestStateType[] | null;
    requestType: RequestType[] | null;
    branch: string | null;
    responsiblePerson: string | null;
}

export const getDefaultAppliedFilters = (): AppliedFiltersType => ({
    state: null,
    requestType: null,
    branch: null,
    responsiblePerson: null,
});
